import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useUpdateEsigningRecipient } from 'app/domains/esigning/hooks/useUpdateEsigningRecipient';
import { StyledSelect } from './styled';
const INVALID_ORDER = -1;
export function RecipientSigningOrder(props) {
    const { recipientId, order } = props;
    const { addToast } = useToast();
    const { signerRecipients } = useEsigningRecipients();
    const { length } = signerRecipients;
    const [updateRecipient, { loading }] = useUpdateEsigningRecipient();
    const options = Array.from({ length }, (_, i) => i);
    const invalidOrder = order !== undefined && order >= length;
    const handleChange = (event) => {
        const newOrder = Number(event.target.value);
        if (newOrder === INVALID_ORDER) {
            return;
        }
        updateRecipient({
            variables: {
                recipientId,
                input: { order: newOrder },
            },
            onError: () => {
                addToast({
                    appearance: 'danger',
                    title: t({
                        message: 'Could not update the party',
                        comment: 'Toast message for error when updating a signing party',
                    }),
                });
            },
        });
    };
    // If the order is invalid we render a select with `-` as value for the user
    // This is to indicate that the order is invalid and the user needs to change it
    return (<StyledSelect size="small" value={invalidOrder ? INVALID_ORDER : order} invalid={invalidOrder} loading={loading} disabled={loading} onChange={handleChange}>
      {invalidOrder && <option value={INVALID_ORDER}>-</option>}
      {order === undefined && <option value={undefined}>#0</option>}
      {options.map((option) => (<option key={option} value={option}>{`#${option + 1}`}</option>))}
    </StyledSelect>);
}
